module.exports = __webpack_public_path__ + "static/img/pisankiok.2c3ae5dc.webp";